import { AssetProps } from '@websrc/App/Components/Asset/Asset'
import { SpotDistributorCardProps } from '@websrc/Spot/Distributor/Card/SpotDistributorCard'
import React from 'react'

import * as SC from './SpotDistributorCardDetails.style'

export interface SpotDistributorCardDetailsProps {
  details: NonNullable<SpotDistributorCardProps['distributor']['details']>
  logo: AssetProps | null
}

export const SpotDistributorCardDetails = ({ details, logo }: SpotDistributorCardDetailsProps) => {
  return (
    <SC.Info>
      <SC.InfoAddress>
        <span>{details.street}</span>
        <span>
          {details.postal_code} {details.town}
        </span>
        <span>{details.country}</span>
      </SC.InfoAddress>
      {details.email && (
        <SC.InfoContact href={`mailto:${details.email}`}>{details.email}</SC.InfoContact>
      )}
      {details.phone && (
        <SC.InfoContact href={`tel:${details.phone}`}>{details.phone}</SC.InfoContact>
      )}
      {logo && <SC.InfoLogo {...logo} />}
    </SC.Info>
  )
}
